import AxiosConfig from "./AxiosConfig";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faFileImport,
    faPersonBurst, faPersonDress,
    faPersonRunning,
    faRemove,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as SablierIcone } from "../icons/asu_file_dattente.svg";
import DateService from "./DateService";

export const USER_STATUS = {
    attenteJustificatif: { value: -2, label: 'Attente de justificatif' },
    attenteValidation: { value: -1, label: '(Coach) Attente de validation par un admin' },
    importe: { value: 0, label: 'Importé' },
    cree: { value: 1, label: 'Compte créé' },
    bloque: { value: 3, label: 'Compte bloqué' },
    supprime: { value: 4, label: 'Compte supprimé' },
}

export const USER_STATUS_VALUE = [
    USER_STATUS.attenteJustificatif.value,
    USER_STATUS.attenteValidation.value,
    USER_STATUS.importe.value,
    USER_STATUS.cree.value,
    USER_STATUS.bloque.value,
    USER_STATUS.supprime.value,
];

const getCurrentUser = async () => {
   try {
       const response = await AxiosConfig.get('/user');
       return response.data;
   } catch (error) {
       console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
       throw error;
   }
};

const getCurrentUserApi = async () => {
    try {
        const response = await AxiosConfig.get('/user');
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
};

const saveProfileLocal = async (formData) => {
    try {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        if (!user) {
            console.error('Aucun utilisateur trouvé dans le localStorage');
            return false;
        }

        user.nom = formData.nom;
        user.prenom = formData.prenom;
        user.date_naissance = formData.birth_date;
        user.email = formData.email;
        user.login = formData.email;
        user.tel_mobile = formData.mobile;
        user.roles = [formData.roles];
        user.lastSeance = {
            id: 1,
            rating: false,
            name: "Yoga",
            coach: "Pierre",
            disableShowRatingModal: false,
            ratingValue: null
        };
        localStorage.setItem('currentUser', JSON.stringify(user));

        return user;
    } catch (error) {
        throw new Error(error);
    }
};

const saveProfileApi = async (formData) => {
    try {
        const response = await AxiosConfig.post('/profil', formData);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
};

const confirmProfileApi = async (formData) => {
    try {
        const response = await AxiosConfig.post('/profil/confirm', formData);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
};

const enrolementProfileApi = async (formData) => {
    try {
        const response = await AxiosConfig.post('/profil/enrolement', formData);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        if (error.response?.data?.message) {
            throw new Error(error.response.data.message);
        }
        throw error;
    }
};

const importUserApi = async (formData) => {
    try {
        const response = await AxiosConfig.post('/user/import', formData);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
};

const parseParticipants = (participants) => {
    if (!participants) return [];
    return participants.map(participant => {
        if (!participant.id) return;

        return {
            key: participant.id,
            name: participant.prenom + " " + participant.nom,
            isSwitchActive: participant.presence,
            status: participant.asu_status,
        };
    });
};

const setPresenceParticipant = async (seanceId, participantId, presence) => {
    try {
        const response = await AxiosConfig.post(`/activite_seance_users/set_presence/${seanceId}/${participantId}`, {"presence": presence});
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
}

const setDesinscrireParticipantByReferent = async (participantId) => {
    try {
        const response = await AxiosConfig.post(`/activite_seance_users/remove_user_to_seance_by_referent/${participantId}`);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
}

const getParticipants = async (queryParams = null) => {
    let url = queryParams ? `/users/participants${queryParams}` : `/users/participants`

    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
}

const parseForListeUtilisateurs = (users) => {
    return users.map(user => {
        return {
            id: user.id,
            name: user.prenom + " " + user.nom,
            sexe: user.sexe, /* === 'madame' ?
                <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaFemale}`}/>
                : <FontAwesomeIcon icon={faFemale} className={`${styles.icone} ${styles.iconeFaMale}`}/>, */
            status: user.status, /* ?
                <FontAwesomeIcon icon={faCheck} className={`${styles.icone} ${styles.iconeFaCheck}`}/>
                : <FontAwesomeIcon icon={faXmark} className={`${styles.icone} ${styles.iconeFaXmark}`}/>, */
            details: {
                email: {
                    label: "Email",
                    value: user.email
                },
                dateInscription: {
                    label: "Date d'inscription",
                    value: user.details.dateInscription ? DateService.formatDate(user.details.dateInscription) : ""
                },
                derniereConnexion: {
                    label: "Dernière connexion",
                    value: user.details.derniereConnexion ? DateService.formatDate(user.details.derniereConnexion) : ""
                },
                inscriptions: {
                    label: "Réservations",
                    value: user.details.inscriptions
                },
                presences: {
                    label: "Présences",
                    value: user.details.presences
                },
                absences: {
                    label: "Absences",
                    value: user.details.absences
                },
                file_attente: {
                    label: "N'a pas pu participer car en liste d'attente",
                    value: user.details.file_attente
                },
                refuse: {
                    label: "N'a pas pu participer car refusé",
                    value: user.details.refus
                },
            }
        }
    });
}

const mapKeyConvivial= (key) => {
    const mapping = {
        dateInscription: "Date d'inscription",
        autreCle: "Autre Libellé",
    };
    return mapping[key] || key;
};

const acceptCgu = async (values) => {
    try {
        const response = await AxiosConfig.post('/user/cgu', values);
        return response;
    } catch (error) {
        console.error("Erreur lors de l'acceptation des CGU :", error);
        throw error;
    }
}

const getUtilisateurWithToken = async (token, mail) => {
    try {
        const response = await AxiosConfig.get(`/get_user/token/${token}/${mail}`);
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des données de l'utilisateur :", error);
        throw error;
    }
}

const sendConfirmMail = async (mail) => {
    try {
        const response = await AxiosConfig.post(`/send_confirm_mail/${mail}`);
        return response.data;
    } catch (error) {
        console.error("Erreur :", error);
        if (error.response?.status === 429) {
            return { success: false, msg: error.response.data?.msg || "Trop de tentatives, veuillez réessayer plus tard." };
        }
        return { success: false, msg: "Une erreur est survenue, veuillez réessayer plus tard." };
    }
}

const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

const parseUtilisateurStatus = (status) => {
    return getUtilisateurStatus(status);

    // const statusObj = USER_STATUS[status];
    // return statusObj ? statusObj.label : USER_STATUS.bloque.label;
}


const getUtilisateurStatus = (status) => {
    switch (status) {
        case USER_STATUS.attenteJustificatif.value:
            return USER_STATUS.attenteJustificatif.label;
        case USER_STATUS.attenteValidation.value:
            return USER_STATUS.attenteValidation.label;
        case USER_STATUS.importe.value:
            return USER_STATUS.importe.label;
        case USER_STATUS.cree.value:
            return USER_STATUS.cree.label;
        case USER_STATUS.bloque.value:
            return USER_STATUS.bloque.label;
        case USER_STATUS.supprime.value:
            return USER_STATUS.supprime.label;
        default:
            return USER_STATUS.supprime.label;
    }
}

const getUtilisateurStatusIcon = (status) => {
    switch (status) {
        case USER_STATUS.attenteJustificatif.value:
            return <SablierIcone style={{ fill: "var(--clr-warning)", width: "20px", height: "auto" }} />; // <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
        case USER_STATUS.attenteValidation.value:
            return <SablierIcone style={{ fill: "var(--clr-danger)", width: "20px", height: "auto" }} />; // <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }}  />;
        case USER_STATUS.importe.value:
            return <FontAwesomeIcon icon={faFileImport} style={{ color: "var(--clr-main)" }} />;
        case USER_STATUS.cree.value:
            return <FontAwesomeIcon icon={faCheck} style={{ color: "var(--clr-success)"}} />;
        case USER_STATUS.bloque.value:
        case USER_STATUS.supprime.value:
        default:
            return <FontAwesomeIcon icon={faRemove} style={{ color: "var(--clr-danger)" }} />;
    }
}

const getUtilisateurRoleLabel = (role) => {
    // Vérifier si role est un tableau
    if (Array.isArray(role)) {
        return role.map(r => {
            switch (r) {
                case "ROLE_USER":
                    return "Utilisateur";
                case "ROLE_COACH":
                    return "Coach";
                case "ROLE_REFERENT":
                    return "Référent";
                case "ROLE_ADMIN":
                    return "Admin";
                case "ROLE_SUPER_ADMIN":
                    return "Super Admin";
                default:
                    return "Inconnu";
            }
        }).join(", ");
    }

    switch (role) {
        case "ROLE_USER":
            return "Utilisateur";
        case "ROLE_COACH":
            return "Coach";
        case "ROLE_REFERENT":
            return "Référent";
        case "ROLE_ADMIN":
            return "Admin";
        case "ROLE_SUPER_ADMIN":
            return "Super Admin";
        default:
            return "Inconnu";
    }
}

const getUtilisateurRoleIcon = (role) => {
    switch (role) {
        case "ROLE_USER":
            return <FontAwesomeIcon icon={faUser} />;
        case "ROLE_COACH":
            return <FontAwesomeIcon icon={faPersonRunning} />;
        case "ROLE_REFERENT":
            return <FontAwesomeIcon icon={faPersonDress} />;
        case "ROLE_ADMIN":
            return <FontAwesomeIcon icon={faPersonBurst} />;
        case "ROLE_SUPER_ADMIN":
            return <FontAwesomeIcon icon={faPersonBurst} />;
        default:
            return <FontAwesomeIcon icon={faUser} />;
    }
}

const fetchToSetUtilisateurActif = async (utilisateur) => {
    try {
        const response = await AxiosConfig.post(`/admin/utilisateurs/${utilisateur.id}/actif`, {"actif": !utilisateur.actif});
        return response.data
    } catch (error) {
        return error;
    }
}

const getUtilisateurs = async (filters = "", url = '/admin/utilisateurs') => {
    if (filters) {
        let cpt = 0;
        for (const [key, value] of Object.entries(filters)) {
            if (value) {
                if (cpt === 0) {
                    url += `?filter_${key}=${value}`;
                } else {
                    url += `&filter_${key}=${value}`;
                }
                cpt++;
            }
        }
    }

    try {
        const response = await AxiosConfig.get(url);
        return response.data;
    } catch (error) {
        console.error('error', error);
        return {
            success: false,
            message: "Une erreur est survenue",
            error: error
        };
    }
}

const validatePassword = (value) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!value) {
        return "Le mot de passe est requis.";
    }
    if (!passwordRegex.test(value)) {
        return "Le mot de passe doit contenir au moins 8 caractères, une minuscule, une majuscule et un chiffre.";
    }
    return null;
};

function validateFormConfirm(values) {
    let errors = {};

    // Validation du nom
    if (!values.nom) {
        errors.nom = 'Le champ Nom est obligatoire';
    }

    // Validation du prénom
    if (!values.prenom) {
        errors.prenom = 'Le champ Prénom est obligatoire';
    }

    if (!values.civilite) {
        errors.civilite = 'Le champ Civilité est obligatoire';
    }

    // Validation de la date de naissance
    if (!values.birth_date) {
        // errors.birth_date = 'La date de naissance est obligatoire';
    }

    // Validation de l'email
    if (!values.email) {
        errors.email = 'Le champ Email est obligatoire';
    } else if (!validEmail(values.email)) {
        errors.email = 'L\'email doit être valide';
    }

    // Validation du mobile
    if (!values.mobile) {
        // errors.mobile = 'Le numéro de mobile est obligatoire';
    }

    // Validation du mot de passe
    if (!values.password) {
        errors.password = 'Le mot de passe est obligatoire';
    }

    if (!values.password_confirm) {
        // errors.password_confirm = 'Le mot de passe est obligatoire';
    }

    if (values.password !== values.password_confirm) {
        errors.password_confirm = 'Les mots de passe ne correspondent pas';
    }

    if (validatePassword(values.password) !== null) {
        errors.password = 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre.';
    }

    // Validation des CGU
    if (!values.cgu) {
        errors.cgu = 'Vous devez accepter les CGU';
    }

    console.warn(errors);
    return errors;
}

function validateFormImport(values) {
    let errors = {};

    // Validation de la civilité
    if (!values.civilite) {
        errors.civilite = 'Le champ Civilité est obligatoire';
    }

    // Validation du nom
    if (!values.nom) {
        errors.nom = 'Le champ Nom est obligatoire';
    }

    // Validation du prénom
    if (!values.prenom) {
        errors.prenom = 'Le champ Prénom est obligatoire';
    }

    // Validation de la date de naissance
    // if (!values.date_naissance) {
    //     errors.date_naissance = 'La date de naissance est obligatoire';
    // }

    // Validation de l'email
    if (!values.email) {
        errors.email = 'Le champ Email est obligatoire';
    } else if (!validEmail(values.email)) {
        errors.email = 'L\'email doit être valide';
    }

    // Si des erreurs alors on affiche les erreurs
    if (Object.keys(errors).length) {
        console.error(errors);
    }

    return errors;
}

function validEmail(email) {
    return  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
}

export {
    getCurrentUser,
    getUtilisateurWithToken,
    saveProfileApi,
    saveProfileLocal,
    confirmProfileApi,
    getCurrentUserApi,
    parseParticipants,
    setPresenceParticipant,
    getParticipants,
    parseForListeUtilisateurs,
    mapKeyConvivial,
    acceptCgu,
    sendConfirmMail,
    validateEmail,
    parseUtilisateurStatus,
    getUtilisateurStatus,
    getUtilisateurStatusIcon,
    fetchToSetUtilisateurActif,
    getUtilisateurRoleLabel,
    getUtilisateurRoleIcon,
    getUtilisateurs,
    validateFormConfirm,
    enrolementProfileApi,
    importUserApi,
    validateFormImport,
    setDesinscrireParticipantByReferent
};